import { render, staticRenderFns } from "./LandingOnboardingFlow.vue?vue&type=template&id=65008e8c&scoped=true"
import script from "./LandingOnboardingFlow.vue?vue&type=script&lang=ts"
export * from "./LandingOnboardingFlow.vue?vue&type=script&lang=ts"
import style0 from "./LandingOnboardingFlow.vue?vue&type=style&index=0&id=65008e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65008e8c",
  null
  
)

export default component.exports